import { Customer } from './customer';

export class Product {

    public id:number;
    public idExternal:string;
    public customer:Customer;
    public name:string;
    public weight:number;
    public quantity:number;
    public price:number;

    constructor (id:number, customer:Customer, name:string, weight:number, quantity:number, price:number) {
        this.id = id;
        this.customer = customer;
        this.name = name;
        this.weight = weight;
        this.quantity = quantity;
        this.price = price;
        
        this.idExternal = null;
    }    


    get idCustom():any {
        if (this.idExternal && this.idExternal.length > 0) {
            return this.idExternal;
        } else {
            return this.id;
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/entities/product.ts